<template>
    <div class="import-entry-row">
        <div class="import-field-title">
            {{ label }}
        </div>
        <div class="import-field-value" v-bind:class="{ empty: ! (value) }">
            {{ (value)?value:"(empty)" }}
        </div>
    </div>
</template>

<script>
export default {
    name: "entry-row",
    props: ['label', 'value'],
    data(){
        return {

        }
    }
}
</script>

<style scoped>

</style>
